<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 pt-2 :class="{'ml-5': $vuetify.breakpoint.mdAndUp}">
        <v-btn
          color="primary"
          outline
          :block="$vuetify.breakpoint.smAndDown"
          class="ml-0"
          @click="open()"
        >
          <v-icon left color="primary">contact_support</v-icon>
          {{ motifs.length }} / {{ $tc('motifs', $store.state._Sites.sites[0].motifs.length, { count: $store.state._Sites.sites[0].motifs.length }) }}
        </v-btn>
      </v-flex>
    </v-layout>

    <!-- Sélectionner les motifs -->
    <v-dialog v-model="dialog" scrollable persistent max-width="350px">
      <v-card>
        <v-card-title class="primary white--text">
          <div class="headline">{{ $t('select') | cap }} {{ $tc('motifs', 2, { count: ' ' }) }}</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px;">
          <v-data-table
            :headers="header"
            :items="motifsInit"
            v-model="motifsTmp"
            item-key="MOT_ID"
            select-all="primary"
            class="elevation-1"
            hide-actions
            :total-items="motifsInit.length"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    color="primary"
                    hide-details
                    @click.native="toggleAll"
                    :input-value="props.all || (motifsTmp.length == motifs.length)"
                    :indeterminate="props.indeterminate"
                  ></v-checkbox>
                </th>
                <th class="text-xs-left">
                  <span class="subheading">{{ header[0].text }}</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td>
                <v-checkbox
                  v-if="props.item.MOT_ID == motifsInit.MOT_ID"
                  color="primary"
                  hide-details
                  value
                  :input-value="iAmChoosen"
                ></v-checkbox>
                <v-checkbox
                  v-else
                  color="primary"
                  hide-details
                  v-model="props.selected"
                ></v-checkbox>
              </td>
              <td>
                <span class="ml-2">
                  {{ props.item.MOT_LABEL }}
                </span>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click="cancel()">{{ $t('cancel') }}</v-btn>
          <v-btn :disabled="motifsTmp.length < min" color="primary" @click="submit()">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { DOMAINE } from '../../constants'
export default {
  props: {
    /**
     * Motifs sélectionnés
     */
    motifs: {
      type: Array,
      required: true
    },
    /**
     * Motifs sélectionnables
     */
    motifsInit: {
      type: Array,
      required: true
    },
    /**
     * Indique le nombre d'Motifs
     * qui doivent être sélectionnés
     */
    min: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      domaine: DOMAINE,
      /**
       * Motifs sélectionnés dans le dialog
       * @type {Array}
       */
      motifsTmp: null,
      /**
       * Indique si le dialog est ouvert
       * @type {Boolean}
       */
      dialog: false
    }
  },

  created () {
    this.motifsTmp = this.motifs
  },

  computed: {
    header () {
      return this.motifsTmp && !this.motifsTmp.length
      ? [{text: _.upperFirst(this.$t('selectnone')), align: 'left', sortable: false}]
      : [{text: _.upperFirst(this.$tc('selectall', 1)), align: 'left', sortable: false}]
    }
  },

  methods: {
    open () {
      this.motifsTmp = this.motifs
      this.dialog = true
    },
    submit () {
      this.$emit('update:motifs', this.motifsTmp)
      this.dialog = false
    },
    cancel () {
      this.dialog = false
    },
    toggleAll () {
      if (this.motifsTmp.length) this.motifsTmp = []
      else this.motifsTmp = this.motifsInit.slice()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheezy/WzSelectMotifs.vue